import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "item", "count", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    const term = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const text = item.dataset.searchText.toLowerCase()
      const visible = term === "" || text.includes(term)
      item.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    this.countTarget.textContent = visibleCount
    this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
  }
}
